import { Text } from '@instabox/consumer-web-ui'
import { FormattedMessage } from 'react-intl'

const PositiveRating = () => {
  return (
    <Text fontSize="sm" fontWeight="medium" italic align="center">
      <FormattedMessage id="help.rating.positive.thanks" />
    </Text>
  )
}

export default PositiveRating
